const adjacent = (left, right) => left && right && Date.parse(left.fine) === Date.parse(right.inizio);
const recorded = segment => segment?.tipo === "attivita" && segment.attivita_ids.length > 0;

// Display only: the API remains authoritative for classifications and totals.
export function compactTimeline(segments) {
    const rows = segments.map(segment => ({ ...segment, attivita_ids: [...segment.attivita_ids] }));
    const compact = [];
    for (let index = 0; index < rows.length; index++) {
        const row = rows[index], previous = compact[compact.length - 1], next = rows[index + 1];
        const shortInterval = row.tipo === "attivita" && !row.attivita_ids.length && row.minuti <= 5;
        if (shortInterval && recorded(previous) && adjacent(previous, row)) {
            previous.fine = row.fine;
            previous.minuti += row.minuti;
            previous.includesShortIntervals = true;
        } else if (shortInterval && recorded(next) && adjacent(row, next)) {
            next.inizio = row.inizio;
            next.minuti += row.minuti;
            next.includesShortIntervals = true;
        } else {
            compact.push(row);
        }
    }
    return compact;
}

export function groupTimeline(segments) {
    const groups = [];
    for (const row of compactTimeline(segments)) {
        const previous = groups[groups.length - 1];
        if (row.tipo === "attivita" && previous?.tipo === "attivita" && adjacent(previous, row)) {
            previous.fine = row.fine;
            previous.minuti += row.minuti;
            previous.attivita_ids = [...new Set([...previous.attivita_ids, ...row.attivita_ids])];
            previous.details.push(row);
        } else {
            groups.push({ ...row, attivita_ids: [...row.attivita_ids], details: row.tipo === "attivita" ? [row] : [] });
        }
    }
    return groups;
}

export function activityGroupLabel(group, byId) {
    const orders = new Set(group.attivita_ids.map(id => byId[id]?.ordine?.trim()).filter(Boolean));
    if (!orders.size) return "Attività senza ODP";
    return `${orders.size} ODP ${orders.size === 1 ? "lavorato" : "lavorati"}`;
}

export function presenceBounds(periods) {
    if (!periods.length) return null;
    const ordered = [...periods].sort((a, b) => Date.parse(a.inizio) - Date.parse(b.inizio));
    const first = ordered[0], last = ordered[ordered.length - 1];
    return {
        entry: { original: first.ingresso, counted: first.inizio },
        exit: { original: last.uscita, counted: last.uscita ? last.fine : null },
    };
}
